<template>
  <div class="mb-3">
    <div class="d-flex justify-content-between">
      <h2 class="fw-light d-flex align-items-center mb-0">Contratos Ativos</h2>
    </div>
  </div>
  <LoadingData v-if="isLoading" />
  <div v-else class="row">
    <div v-for="(item, index) in data" :key="index" class="col">
      <div class="card border-start border-start-width-2 border-start-primary">
        <div class="card-body">
          <h4 class="fw-light text-center text-primary mb-0">
            {{ item.tipo }}
          </h4>
          <hr class="my-2" />
          <div
            class="d-flex flex-lg-row flex-column align-items-center justify-content-between"
          >
            <div class="text-center">
              <h2 class="mb-0 fw-lighter">{{ item.qtd }}</h2>
              <p>Quantidade</p>
            </div>
            <div>
              <p>
                <strong>Valor estimado para pagamento: </strong>
                {{ formatToCurrencyBr(item.saldo) }}
              </p>
              <p class="mb-0">
                <strong>Valor total contratado: </strong>
                {{ formatToCurrencyBr(item.valorTotal) }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoadingData from '@/components/commons/LoadingData.vue'
import { mapGetters } from 'vuex'
import { formatToCurrencyBr } from '@/utils/currency'

export default {
  name: 'ActivesDocs',

  components: {
    LoadingData,
  },

  data() {
    return {
      isLoading: true,
      data: [],
      formatToCurrencyBr,
    }
  },

  computed: {
    ...mapGetters(['isManager', 'isFinancialManager']),
  },

  methods: {
    async getDashboard() {
      try {
        this.data = await this.$store.dispatch('getDashboard')
        this.isLoading = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },
  },

  mounted() {
    this.getDashboard()
  },
}
</script>
